import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getSingularUGCByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'iOwnThisTransactions'], Immutable.Map());

export const getIOwnThisByUsers = getSingularUGCByUsers('iOwnThis');

export const getIOwnThisTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getIOwnThisByUsers,
  getIOwnThisTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/IOwnThisSelector.js